import { TRANSLATION_ACTIONS } from "../../actions/translationActions";

const translationDataReducer = (state = {
  data: null
}, action) => {
  switch (action.type) {
    case TRANSLATION_ACTIONS.FETCH_ALL_TRANSLATIONS_DATA_SUCCESS: {
      state = {
        ...state,
        data: action.payload
      };
      break;
    }
    default: 
      break;
  }
  return state;
};

export default translationDataReducer;
